import type { DashboardWidget } from '@/api/types';
import { formatKpi } from './format';

export type Trend = NonNullable<DashboardWidget['trend']>;
export type Sentiment = NonNullable<DashboardWidget['sentiment']>;

/** Same rules as mydash_core::kpi (FLAT_THRESHOLD_PCT = 0.05). Used when the API omits them. */
export function trendOf(pct: number | null | undefined): Trend {
  if (pct === null || pct === undefined || Number.isNaN(pct)) return 'none';
  if (Math.abs(pct) < 0.05) return 'flat';
  return pct > 0 ? 'up' : 'down';
}

export function sentimentOf(trend: Trend, higherIsBetter: boolean | null | undefined): Sentiment {
  if ((trend === 'up' && higherIsBetter === true) || (trend === 'down' && higherIsBetter === false)) return 'good';
  if ((trend === 'up' && higherIsBetter === false) || (trend === 'down' && higherIsBetter === true)) return 'bad';
  return 'neutral';
}

/** The card's display value: the server's `formatted_value`, or the same rules locally. */
export function displayValue(
  w: Pick<DashboardWidget, 'unit'> & Partial<Pick<DashboardWidget, 'formatted_value' | 'value' | 'currency' | 'text_value'>>,
): string {
  if (w.unit === 'text') return w.text_value || w.formatted_value || '—';
  return w.formatted_value || formatKpi(w.value ?? null, w.unit, w.currency ?? null, w.text_value ?? null);
}

export function widgetTrend(
  w: Partial<Pick<DashboardWidget, 'trend' | 'sentiment' | 'change_pct' | 'higher_is_better'>>,
): { trend: Trend; sentiment: Sentiment } {
  const trend = w.trend ?? trendOf(w.change_pct);
  return { trend, sentiment: w.sentiment ?? sentimentOf(trend, w.higher_is_better) };
}
